import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Activity {
  id: number
  type_name: string
  date: string
  user_name: string
  description: string
  route: string
  ip_address: string
}

interface Props {
  activities: Activity[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/activities" },
  { title: "Activity Log", href: "/admin/activities" },
]

export default function Index({ activities }: Props) {
  const handleDelete = (id: number) => {
    if (confirm("Are you sure you want to delete this activity entry?")) {
      router.delete(`/admin/activities/${id}`)
    }
  }

  const handleDeleteAll = () => {
    if (
      confirm(
        "Are you sure you want to delete ALL activity entries? This cannot be undone.",
      )
    ) {
      router.delete("/admin/activities/destroy_all")
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Activity Log" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Activity Log</h1>
          {activities.length > 0 && (
            <button
              onClick={handleDeleteAll}
              className="bg-hpi-red hover:bg-hpi-red/80 rounded px-4 py-2 text-white"
            >
              Delete All
            </button>
          )}
        </div>

        {activities.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Type
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Date
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  User
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Details
                </th>
                <th className="border-hpi-light-gray w-16 border px-4 py-2 text-center">
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              {activities.map((activity) => (
                <tr key={activity.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2 align-top">
                    {activity.type_name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2 align-top">
                    {activity.date}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2 align-top">
                    {activity.user_name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2 align-top">
                    <div>{activity.description}</div>
                    {activity.route && (
                      <div className="text-hpi-med-gray text-sm">
                        Route: {activity.route}
                      </div>
                    )}
                    {activity.ip_address && (
                      <div className="text-hpi-med-gray text-sm">
                        IP: {activity.ip_address}
                      </div>
                    )}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2 text-center align-top">
                    <button
                      onClick={() => handleDelete(activity.id)}
                      className="text-hpi-red hover:text-hpi-red/70"
                      title="Delete"
                    >
                      <i className="fa fa-trash" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-green">No activity :)</p>
        )}
      </div>
    </AppLayout>
  )
}
